export class EnvModel {
  production: boolean;
  api: string;
  apiJsonDemo: string;
  filesUrl: string;
  localInstance: string;
  version: string;
}